import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';
import _ from 'lodash';

class Usuarios extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.USUARIOS)
            return null;

        const token = this.props.token;

        const permissions = this.props.users.permissions;
        const profiles = this.props.users.profiles;
        const centers = this.props.users.centers;
        const defaultCenterId = this.props.users.fortalezaId;
        const productCategories = this.props.users.productCategories;

        const editorFields = [
            {
                type:  "radio",
                label: "Ativo:",
                name:  "active",
                options: [
                    { label: "Sim", value: true },
                    { label: "Não", value: false },
                ],
                def: true,
            },
            {
                label: "Nome:",
                name: "name"
            },
            {
                label: "Nome de Usuário:",
                name: "username"
            },
            { label: "Senha:", name: "password1", type: "password" },
            { label: "Repita sua senha:", name: "password2", type: "password" },
            {
                "label": "Núcleo:",
                "name": "center.id",
                "type": "select",
                "options": _.map(centers, function (center) { return center.toJS(); }),
                "optionsPair": {
                    "label": "name",
                    "value": "id"
                },
                def: defaultCenterId,
            },
            {
                type:  "checkbox",
                label: "Perfis:",
                name:  "profiles[].id",
                options: profiles,
                optionsPair: { label: 'name', value: 'id' }
            },
            {
                type:  "checkbox",
                label: "Permissões:",
                name:  "permissions[].id",
                options: permissions,
                optionsPair: { label: 'friendlyName', value: 'id' }
            },
            {
                type:  "checkbox",
                label: "Permissões de Vendas de Produtos:",
                name:  "productCategories[].id",
                options: productCategories,
                optionsPair: { label: 'name', value: 'id' }
            },
        ];

        const datatablesColumns = [
            { data: "name", title: "Nome", render: $.datatable.renders.text() },
            { data: "username", title: "Nome de Usuário", render: $.datatable.renders.text() },
            { data: "center.name", title: "Núcleo", render: $.datatable.renders.text() },
            { data: "active", title: "Ativo", render: $.datatable.renders.booleanOnlyTrue() },
            { data: "dateCreated", title: "Criação", render: $.datatable.renders.datetime(), width: 160 },
            { data: "dateUpdated", title: "Edição", render: $.datatable.renders.datetime(), width: 160 },
        ];

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/users/select',
            createUrl: '/api/users/insert',
            editUrl: '/api/users/update/_id_',
            removeUrl: '/api/users/delete/_id_',
        });

        const editorCreateTitle = 'Inserir administrador';
        const editorEditTitle = 'Editar administrador';
        const editorRemoveTitle = 'Remover administrador';
        const editorRemoveMessage = 'Deseja remover este administrador?';

        const domClassName = 'users-datatables';
        const title = 'Administradores';
        const subTitle = 'Gerenciamento';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       pageLength={100}
                       responsive={true}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

export default Usuarios;


// WEBPACK FOOTER //
// src/views/pages/Usuarios.jsx